import { Component, OnInit } from '@angular/core';
import { StringHelper } from 'src/app/helpers/string-helper';
import { SignStickerDetail } from 'src/app/model/sign/sticker/sign-sticker-detail';
import { SignStickerOverview } from 'src/app/model/sign/sticker/sign-sticker-overview';
import { SignStickerControllerRequestService } from 'src/app/services/api/sign-associations/implementations/sign-sticker-controller-request.service';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { AssociationOption } from '../helper/interfaces/association-option';
import { IPBoardAssociationPickerComponent } from '../ip-board-association-picker.component';
import IPBoardPart from '../../../../../../model/product/ip-board/ip-board-part';

@Component({
  selector: 'ip-board-sticker-picker',
  templateUrl: './ip-board-sticker-picker.component.html',
  styleUrls: ['./ip-board-sticker-picker.component.scss']
})
export class IPBoardStickerPickerComponent
  extends IPBoardAssociationPickerComponent<SignStickerOverview>
  implements OnInit {
  withSticker: boolean = false;
  hide: boolean = true;

  constructor(
    protected signStickerControllerRequestService: SignStickerControllerRequestService,
    protected projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super(
      signStickerControllerRequestService,
      projectDisplayObservableService,
      'Sticker',
      'Gewenste sticker',
      '',
      true,
      false,
      false,
      false,
      'previousStickerContent',
      null
    );
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.withSticker = this.ipBoardPart.sticker != null;
  }

  protected initializeAssociationOption(
    option: SignStickerOverview
  ): AssociationOption<SignStickerOverview> {
    return {
      label: option.text,
      representsDefaultOption: false,
      value: option
    };
  }

  protected afterInitializeSelectedOptions(): void {
    this.withSticker =
      this.selectedOption != null || !StringHelper.isEmpty(this.otherValue);
    if (this.otherOptionHasValue()) {
      this.selectedOption = this.associationOptions[
        this.associationOptions.length - 1
      ];
    }
  }

  protected initializeDefaultOption(
    ipBoardpart: IPBoardPart
  ): AssociationOption<SignStickerOverview> {
    throw new Error('Method not implemented.');
  }

  protected initializeOtherValue(): string {
    return this.ipBoardPart.otherSticker;
  }

  protected initializeOtherSideOtherValue(): string {
    throw new Error('Method not implemented.');
  }

  protected getCurrentSelectedOption(
    ipBoardPart: IPBoardPart
  ): SignStickerOverview {
    return ipBoardPart.sticker;
  }

  protected getCurrentSelectedOtherSideOption(): SignStickerOverview {
    throw new Error('Method not implemented.');
  }

  protected getOtherOptionLabel(): string {
    return 'Andere sticker';
  }

  protected wasDefaultOptionSelected(ipBoardPart: IPBoardPart): boolean {
    throw new Error('Method not implemented.');
  }

  protected wasOtherSideDefaultOptionSelected(): boolean {
    throw new Error('Method not implemented.');
  }

  protected wasOtherOptionSelected(): boolean {
    return (
      this.ipBoardPart.sticker == null &&
      !StringHelper.isEmpty(this.ipBoardPart.otherSticker)
    );
  }

  protected otherOptionHasValue(): boolean {
    return (
      this.ipBoardPart.sticker == null &&
      !StringHelper.isEmpty(this.ipBoardPart.otherSticker)
    );
  }

  protected getOtherOptionValue(): string {
    return this.ipBoardPart.otherSticker;
  }

  protected wasOtherSideOtherOptionSelected(): boolean {
    throw new Error('Method not implemented.');
  }

  protected otherSideOtherOptionHasValue(): boolean {
    throw new Error('Method not implemented.');
  }

  protected getOtherSideOtherOptionValue(): string {
    throw new Error('Method not implemented.');
  }

  protected evaluateShowOtherSidePicker(): boolean {
    throw new Error('Method not implemented.');
  }

  protected doSetOptionValue(value: SignStickerOverview): void {
    this.ipBoardPart.sticker = <SignStickerDetail>value;
  }

  protected doSetOtherValue(): void {
    this.ipBoardPart.otherSticker = this.otherValue;
  }

  protected doSetOtherOptionValue(value: SignStickerOverview): void {
    throw new Error('Method not implemented.');
  }

  protected doSetOtherSideOtherValue(): void {
    throw new Error('Method not implemented.');
  }

  protected resetOtherSide(): void {}

  withStickerChanged(): void {
    if (!this.withSticker) {
      this.selectedOption = null;
      this.otherValue = null;
      this.ipBoardPart.sticker = null;
      this.ipBoardPart.otherSticker = null;
      this.emitValueChanged.next();
      this.save.emit();
    } else if (this.ipBoardPart.sign == null) {
      this.selectedOption = this.associationOptions[
        this.associationOptions.length - 1
      ];
    }
  }

  protected getDefaultTextFromSign(): string {
    return '';
  }

  protected getTextFromOption(option: SignStickerOverview): string {
    return option.text;
  }

  protected alwaysRememberPreviousValues(): boolean {
    return true;
  }
}
